// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"91dd7060","418":"e80e21da","453":"387716b5","480":"42dc21c7","638":"39c621c6","854":"004999d0"}[chunkId] + ".chunk.js";
};